import { useEffect, useState } from 'react';
import { addTocartBogoHandler } from '../../../Utils/productAction';
import { getProductIds } from '../../StoreHomePage/BogoClothDiaper/common';
import { fireAddProductEvent } from '../../StoreHomePage/BogoClothDiaper/instrumentation';
import {
  AddButton,
  Card,
  Discount,
  ImageWrapper,
  Overlay,
  ProductAge,
  ProductCardPrice,
  ProductPrice,
  RatingSectionNew,
  StrikePrice,
  StyledImage,
  TotalAmount,
} from './styled';
import { B2G1FreeDiaperPantsSkus } from '../../CartOverlayContainer/Cart/Constants';
import { images } from '../../../Constants/ImageUrls';
import { formatIndianNumber } from '../../../Utils/productPageUtils';

export default function ProductCard(props) {
  const {
    data,
    productId,
    isLocked,
    setChangeCartCount,
    offerCartData,
    setOfferCartData,
    items,
    setShowAnimation,
    showB2g1Snackbar,
    setShowHeader,
    setShowTop,
    showNewCDDDPage,
  } = props;

  const [addedToCartText, setAddedToCartText] = useState('+ Add for FREE');
  const [iosClass, setIosClass] = useState('');
  const outOfStockProduct = data.status == '4';

  const freebieProductData = B2G1FreeDiaperPantsSkus.find(
    (ele) => ele.skuId == productId,
  );

  const freebieSkus = B2G1FreeDiaperPantsSkus.map((ele) =>
    ele.skuId.toString(),
  );

  const handleClick = async () => {
    const freebieProductAdded = items.find((ele) =>
      freebieSkus.includes(ele.toString()),
    );
    if (!isLocked) {
      if (freebieProductAdded != productId) {
        const offerCode = offerCartData?.offerData?.offerCode;
        fireAddProductEvent(data, productId, offerCode);
        const params = {
          productId: productId,
          ids: getProductIds(offerCartData?.productList),
          add: false,
          less: false,
          addToCart: true,
          selectedProductId: productId,
          changeProduct: freebieProductAdded,
        };
        if (setChangeCartCount) {
          setChangeCartCount(true);
        }
        const offerCart = await addTocartBogoHandler(params, false, '4');
        setOfferCartData(offerCart?.data);
        setAddedToCartText('Added');
        if (freebieProductAdded) {
          showB2g1Snackbar('Free Diaper Replaced in cart');
        }
      } else {
        showB2g1Snackbar('You have already selected this diaper pant.');
      }
    }
  };

  const clickAnimationHandler = () => {
    if (outOfStockProduct) {
      showB2g1Snackbar('Product is out of stock');
    } else if (isLocked) {
      document.getElementById(`twoGrid`)?.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
      });
      setShowAnimation(true);
      setTimeout(() => {
        setShowAnimation(false);
        setShowHeader('-56px');
        setShowTop(true);
      }, 1000);
    } else {
      handleClick();
    }
  };

  useEffect(() => {
    if (freebieSkus?.some((ele) => items?.includes(parseInt(ele)))) {
      if (items?.includes(parseInt(productId))) {
        setAddedToCartText('Added');
      } else {
        setAddedToCartText('Change Size');
      }
    } else {
      setAddedToCartText('+ Add for FREE');
    }
  }, [items]);

  useEffect(() => {
    if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
      setIosClass('ios-device');
    }
  }, []);

  return (
    <Card onClick={clickAnimationHandler} showNewCDDDPage={showNewCDDDPage}>
      <ImageWrapper showNewCDDDPage={showNewCDDDPage}>
        <StyledImage
          src={data.image}
          alt={`${data?.name}`}
          loading="lazy"
          showNewCDDDPage={showNewCDDDPage}
        />
        <Overlay
          isLocked={isLocked}
          showNewCDDDPage={showNewCDDDPage}
          outOfStockProduct={outOfStockProduct}
        >
          <div>
            <img
              src={
                outOfStockProduct
                  ? 'https://images.myloapp.in/NestJsUploads/1746533844479-OOS-1.svg'
                  : 'https://images.myloapp.in/NestJsUploads/1737022945546-Lock.svg'
              }
              alt=""
            />
            {outOfStockProduct ? (
              <p>Out of stock</p>
            ) : (
              <p>
                Select 2 Cloth diapers
                <br /> to unlock for free
              </p>
            )}
          </div>
        </Overlay>
      </ImageWrapper>
      <ProductCardPrice
        className={iosClass ? iosClass : ''}
        showNewCDDDPage={showNewCDDDPage}
      >
        <h4>{freebieProductData?.name}</h4>
        <RatingSectionNew showNewCDDDPage={showNewCDDDPage}>
          <img src={images.newFilledStar} alt="" />
          <p>{data?.starRating}</p>
          <span>
            {'('}
            {formatIndianNumber(
              data?.starRatingSubScript?.replace(/[()]/g, ''),
            )}
            {')'}
          </span>
        </RatingSectionNew>
        <ProductAge showNewCDDDPage={showNewCDDDPage}>
          {data?.productAge} baby
        </ProductAge>
        <ProductPrice showNewCDDDPage={showNewCDDDPage}>
          <TotalAmount card>
            <span>{data?.price}</span>
          </TotalAmount>
          <StrikePrice className="span">
            <span>₹{data?.strikeprice}</span>
          </StrikePrice>
          <Discount className="span">
            <span> 100% Off</span>
          </Discount>
        </ProductPrice>
        <AddButton
          addedToCart={addedToCartText == 'Added'}
          showNewCDDDPage={showNewCDDDPage}
          outOfStockProduct={outOfStockProduct}
        >
          {addedToCartText}
        </AddButton>
      </ProductCardPrice>
    </Card>
  );
}
